module.exports = __webpack_public_path__ + "media/images/lig/shirt-carousel/shirt-06-10013afe2be69c3dedf9d8aa5132b94b.jpg";